import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { I18nService } from '@app/i18n/services';
import { FeedbackData, FeedbackService, FeedbackStyle, FeedbackTitle } from '@services/feedback';
import { ProgressIndicatorService } from '@services/progress';

import { IManagedUser, UsersService } from '../../../../../../services/users';
import { ISuspendToggleDialogData } from './users-suspend-toggle.models';

@Component({
	selector: 'app-users-suspend-toggle',
	templateUrl: './users-suspend-toggle.dialog.html'
})
export class UsersSuspendToggleDialogComponent {
	constructor(
		private i18nService: I18nService,
		private feedbackService: FeedbackService,
		private usersService: UsersService,
		private progressIndicatorService: ProgressIndicatorService,
		@Inject(MAT_DIALOG_DATA) public dialogData: ISuspendToggleDialogData,
		private dialogRef: MatDialogRef<UsersSuspendToggleDialogComponent>
	) {}

	public onFormSubmit(): void {
		this.feedbackService.confirm({
			title: FeedbackTitle.warning,
			message: this.dialogData.user.suspended
				? this.i18nService.get('', 'app.prompt.users.suspend-toggle.confirm-unsuspend-message')
				: this.i18nService.get('', 'app.prompt.users.suspend-toggle.confirm-suspend-message'),
			style: FeedbackStyle.error,
			callback: (confirmed: boolean) => {
				if (confirmed) {
					this.suspendToggle();
				} else {
					this.dialogRef.close();
				}
			}
		});
	}

	private suspendToggle(): void {
		this.progressIndicatorService.spinner(true);

		const observable = this.dialogData.user.suspended
			? this.usersService.unsuspendUserAccount(
					this.dialogData.user.id,
					this.dialogData.user.identities['COGNITO']
			  )
			: this.usersService.suspendUserAccount(
					this.dialogData.user.id,
					this.dialogData.user.identities['COGNITO']
			  );

		observable.subscribe(
			(res: IManagedUser) => {
				this.progressIndicatorService.spinner(false);
				this.dialogRef.close();
				this.dialogData.callback(this.dialogData.user);

				const msg =
					res.suspended === this.dialogData.user.suspended
						? this.i18nService.get(
								'Failed to update users account status.',
								'app.descriptor.users.account-status-update-failed'
						  )
						: res.suspended
						? this.i18nService.get('User suspended.', 'app.descriptor.users.suspended')
						: this.i18nService.get('User unsuspended.', 'app.descriptor.users.unsuspended');

				this.feedbackService.notification({
					msg,
					config: { duration: 4000 }
				});
			},
			(error: any) => {
				this.feedbackService.apiError(error);
				this.progressIndicatorService.spinner(false);
			}
		);
	}
}
